export default __webpack_public_path__ + "static/media/731.89a2b752.gif";